export const mobile = {
  'backoffice.mobile.tabs.home': 'Inicio',
  'backoffice.mobile.tabs.accounts': 'Cuentas',
  'backoffice.mobile.tabs.profits': 'Ganancias',
  'backoffice.mobile.tabs.commissions': 'Comisiones',
  'backoffice.mobile.tabs.more': 'Más',
  'backoffice.mobile.more.myProfitHistory': 'Mi Historial de Ganancias',
};
